import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const UserMenuCloseIconDefaultBox = styled.i`
    display: block;
    width: 3.5rem;
    height: 3.5rem;
    background-image: url("${({theme}) => theme.images.spriteSheet.toString()}");
    background-repeat: no-repeat;
    background-position: -855px -641px;
    ${CssRule.For.mobile.build()} &{
        background-position: -899px -639px;
    }
    &:hover {
        cursor: pointer;
    }
`;

const UserMenuCloseIconCasino777DefaultBox = styled(UserMenuCloseIconDefaultBox)`
    background-position: -582px -574px;
    ${CssRule.For.mobile.build()} &{
        background-position: -581px -573px;
    }
`;

export const UserMenuCloseIconBox = styledByTheme(UserMenuCloseIconDefaultBox).forCasino777(UserMenuCloseIconCasino777DefaultBox).apply();
